import React from 'react';
import './ConfigFormProgress.css';

/**
 * Live required-field completion indicator for create forms.
 */
const ConfigFormProgress = ({ completed = 0, total = 0, label }) => {
  if (!total) return null;
  const percent = Math.min(100, Math.max(0, Math.round((completed / total) * 100)));
  const displayLabel = label || `${completed} of ${total} required fields complete`;
  const isComplete = percent === 100;

  return (
    <div className="config-form-progress">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="config-form-progress__label">{displayLabel}</span>
        <span className="config-form-progress__pct text-muted">{percent}%</span>
      </div>
      <div
        className="config-form-progress__track"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={displayLabel}
      >
        <div
          className={`config-form-progress__fill ${isComplete ? 'is-complete' : ''}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default ConfigFormProgress;
